import React, {useEffect, useState} from "react";
import {deleteResource, getByIdResource} from "../../service/http-service";
import './ProfileSegmentStyle.css';
import Plus from '../../../assets/img/profile-images/Otvori-icon.png';
import Minus from '../../../assets/img/profile-images/Zatvori-icon.png';
import Edit from '../../../assets/img/profile-images/Uredi-icon.png';
import Delete from '../../../assets/img/profile-images/Izbrisi-icon.png';
import DeleteModal from "../../ui/DeleteModal";
import {GenericEditModalForm} from "./GenericEditModalForm";


export const ProfileEducationSegment = ({candidate, isPreview}) => {

    const [resultListEmpty, setResultListEmpty] = useState(true);
    const [showOneElement, setShowOneElement] = useState(true);
    const [candidateExistingList, setCandidateExistingList] = useState([]);
    const [firstElementFromList, setFirstElementFromList] = useState({})
    const [updateEducation, setUpdateEducation] = useState(false)
    const [showEducationMessage, setShowEducationMessage] = useState(false)


    const [entity, setEntity] = useState({candidate: candidate});
    const [addEntity, setAddEntity] = useState(false);
    const [updateEntity, setUpdateEntity] = useState(false)




    const educationMessage = (candidateExistingEducationList) => {
        if(candidateExistingEducationList.length <= 0){
            setShowEducationMessage(true)
        } else {
            setShowEducationMessage(false)
        }
    }

    const getCandidateExistingEducationList = () => {
        getByIdResource('candidate_educations/get_by_candidate', candidate.id).then(data => {
            setCandidateExistingList(data.data);
            setFirstElementFromList(data.data[0])
            if(data.data && data.data.length > 1){
                if(isPreview){
                    setShowOneElement(false);
                }
                setResultListEmpty(false)
            } else if(data.data && data.data.length === 1){
               setResultListEmpty(false)
            }else {
                setResultListEmpty(true);
            }
            educationMessage(data.data);
        })
    }
    const confirmDelete = (data, url, refreshEntity, setRefreshEntity) => {
        deleteResource(url, data).then(() =>{
            setRefreshEntity(!refreshEntity);
        }).catch((error) => {
            console.log('error')
        })
    }

    useEffect(()=> {
        getCandidateExistingEducationList();
    },[])

    useEffect(() => {
        getCandidateExistingEducationList()
    }, [updateEducation, updateEntity])





    return(
        <div className='profile_segment_main_container'>
            {showEducationMessage &&
                <small className="text-danger">
                    Доколку не внесете најмалку едно образование нема да бидете земени во предвид и вашите податоци ќе бидат избришани во рок од 2 недели!
                </small>}
            {(firstElementFromList && candidateExistingList && candidateExistingList.length > 0) && showOneElement ?
                <div className='profile_segment_separate_info d-flex justify-content-between'>
               <div>
                   <h5>{firstElementFromList && firstElementFromList.educationType &&
                       firstElementFromList.educationType.name}</h5>
                   <p>Година на запишување: <span>{firstElementFromList.enrollmentDate}</span></p>
                   {firstElementFromList.completionDate &&
                       <p>Година на завршување: <span>{firstElementFromList.completionDate}</span></p>}
                   {firstElementFromList.educationInstitution &&  <p>Назив на институција: <span>
                        {firstElementFromList.customEducationInstitution ?
                            firstElementFromList.customEducationInstitution :
                            firstElementFromList.educationInstitution &&
                            firstElementFromList.educationInstitution.name}
                    </span></p>}
                   {firstElementFromList.educationTitle &&
                       <p>Насока на образование: <span>{firstElementFromList.customEducationTitle
                           ? firstElementFromList.customEducationTitle :
                           firstElementFromList.educationTitle &&
                           firstElementFromList.educationTitle.name}</span></p>}
                   {firstElementFromList.educationSchool && <p>Назив на факултет: <span>
                        {firstElementFromList.customEducationSchool ?
                            firstElementFromList.customEducationSchool :
                            firstElementFromList.educationSchool &&
                            firstElementFromList.educationSchool.name}
                    </span></p>}
                   {firstElementFromList.averageGrade && <p>Просечна оцена: <span>
                        {firstElementFromList.averageGrade}
                    </span></p>}
               </div>
                   <div className="icons-div justify-self-end">
                       {!isPreview &&  <div className="edit_delete_icons">
                           <img src={Edit} alt="edit"  onClick={() => {
                               setShowOneElement(false)
                               setEntity(firstElementFromList)
                               setAddEntity(true)}
                           }/>
                           <DeleteModal btnText={<img src={Delete} alt="delete"/>}  btnClass="apply-btn" confirmDelete={() =>
                               confirmDelete(firstElementFromList, 'candidate_educations', updateEducation, setUpdateEducation)}/>
                       </div>}
                   </div>

            </div> :
                candidateExistingList.map(entity => <>
                <div className='profile_segment_separate_info d-flex justify-content-between'
                     key={entity.id}>
                   <div>
                       <h5>{entity.educationType && entity.educationType.name}</h5>
                       <p>Година на запишување: <span>{entity.enrollmentDate}</span></p>
                       {entity.completionDate &&  <p>Година на завршување: <span>{entity.completionDate}</span></p>}
                       {entity.educationInstitution &&  <p>Назив на институција:
                           <span> {entity.customEducationInstitution ? entity.customEducationInstitution :
                               entity.educationInstitution && entity.educationInstitution.name}
                    </span></p>}
                       {entity.educationTitle &&  <p>Насока на образование:
                           <span> {entity.customEducationTitle ? entity.customEducationTitle :
                               entity.educationTitle && entity.educationTitle.name}</span></p>}
                       {entity.educationSchool && <p>Назив на факултет: <span>
                        {entity.customEducationSchool ? entity.customEducationSchool :
                            entity.educationSchool && entity.educationSchool.name}
                    </span></p>}
                       {entity.averageGrade && <p>Просечна оцена: <span>
                        {entity.averageGrade}
                    </span></p>}
                   </div>
                   <div className="icons-div justify-self-end">
                       {!isPreview && <div className="edit_delete_icons">
                           <img src={Edit} alt="edit" onClick={() => {
                               setEntity(entity)
                               setAddEntity(true)}
                           }/>
                           <DeleteModal btnText={<img src={Delete} alt="delete"/>}  btnClass="apply-btn" confirmDelete={() =>
                               confirmDelete(entity, 'candidate_educations', updateEducation, setUpdateEducation)}/>
                       </div>}
                   </div>
                </div>
                        <hr/>
                    </>
                )}

            {!isPreview && !addEntity && (!showOneElement || resultListEmpty ) && (<div className="profile_add_button mt-3"
                                                                          onClick={() =>
                                                                          {setEntity({...entity, candidate: candidate})
                                                                              setAddEntity(true)}}
            >Додади образование</div>)}
            {addEntity === true && (<div className="open-form">  <GenericEditModalForm
                type="EDUCATION"
                title= {!entity.id ? "Додади образование" : "Уреди образование"}
                entity={entity} setEntity={setEntity}
                addEntity={addEntity} setAddEntity={setAddEntity}
                updateEntity={updateEntity} setUpdateEntity={setUpdateEntity}/></div>)}


            {(!isPreview && !resultListEmpty) &&
               <>
                   <div className='profile_plus_container'><hr/>
                       {showOneElement ?  <img src={Plus} alt='plus' onClick={()=> setShowOneElement(false)}/> :
                           <img src={Minus} alt='plus' onClick={()=> {
                               setShowOneElement(true)
                               setAddEntity(false)}
                           }/>}
                   </div>
               </>
            }
        </div>
    )
}